const tablist = [
  {
    text: "Company Tagline",
  },
  {
    text: "Features",
  },
  {
    text: "Completely Integrated",
  },
  {
    text: "Powering Sports Analysis",
  },
  {
    text: "Get Premium free for 2 weeks",
  },
  {
    text: "Software Strengths",
  },
  {
    text: "Testimonials",
  },
];
export { tablist };
